<template>
  <div class="dataBox">
    <span>费用缴纳成功，请等待最终确认...</span>
  </div>
</template>

<script>
export default {
  name: 'processPaysuccess'
}
</script>

<style scoped>
  .dataBox{
    padding-top: 180px;
  }
  .dataBox span{
    color: #1c7430;
    font-size: 18px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/joinprocess/processPaysuccess.vue